import { createRouter, createWebHistory } from "vue-router";
import NotFoundView from "../views/NotFoundView.vue";
import AuthView from "../views/AuthView.vue";
import EmailAuthView from "../views/EmailAuthView.vue";
import ConfigView from "../views/ConfigView.vue";
import CalendarCallbackView from "../views/CalendarCallbackView.vue";
import CalendarCallbackViewV2 from "../views/CalendarCallbackViewV2.vue";
import SubscriptionResultView from "../views/SubscriptionResultView.vue";
import SubscriptionPaymentView from "../views/SubscriptionPaymentView.vue";
import ShareView from "../views/ShareView.vue";

const services = ["notion"];
const skills = { notion: ["export-transcript", "export-summary"] };

const routes = [
  {
    path: "/",
    name: "NotFound",
    component: NotFoundView,
    redirect: () => {
      window.location.href = "https://shadow.do";
    },
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
  {
    path: "/r/:code",
    name: "AuthRedirect",
    component: AuthView,
  },
  {
    path: "/auth/invite",
    name: "AuthView",
    component: AuthView,
  },
  {
    path: "/auth/email",
    name: "EmailAuth",
    component: EmailAuthView,
  },
  {
    path: "/config/:service/:skillId",
    name: "config",
    component: ConfigView,
    beforeEnter: (to, from, next) => routerCheck(to, from, next),
  },
  {
    path: "/calendar/oauth2callback",
    name: "CalendarCallback",
    component: CalendarCallbackView,
  },
  {
    path: "/calendar/callback",
    name: "CalendarCallbackV2",
    component: CalendarCallbackViewV2,
  },
  {
    path: "/subscription/payment",
    name: "SubscriptionPayment",
    component: SubscriptionPaymentView,
  },
  {
    path: "/subscription/result",
    name: "SubscriptionResult",
    component: SubscriptionResultView,
  },
  {
    path: "/share/:shareId/:skillCustIdx?",
    name: "Share",
    component: ShareView,
    props: true,
    beforeEnter: (to, from, next) => {
      const { shareId } = to.params;
      const regex = /^[a-zA-Z0-9]{8}$/;
      if (shareId.length === 8 && regex.test(shareId)) next();
      else next("/404");
    },
  },
  // {
  //   path: "/auth/:service/",
  //   name: "auth",
  //   component: AuthView,
  //   beforeEnter: (to, from, next) => routerCheck(to, from, next),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

/* 라우터 체크 */
function routerCheck(to, from, next) {
  let isValidService =
    to.params.service != null && services.includes(to.params.service);
  let isValidSkill =
    Object.keys(skills).includes(to.params.service) &&
    skills[to.params.service].includes(to.params.skillId);

  if (!isValidService || (to.name == "config" && !isValidSkill)) {
    next("/");
    return;
  }

  // if (to.name == "skill" && ) {

  // }

  next();
}

export default router;
